import { render, staticRenderFns } from "./DutyInfoList.vue?vue&type=template&id=74ce74c6&scoped=true&"
import script from "./DutyInfoList.vue?vue&type=script&lang=ts&"
export * from "./DutyInfoList.vue?vue&type=script&lang=ts&"
import style0 from "./DutyInfoList.vue?vue&type=style&index=0&id=74ce74c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ce74c6",
  null
  
)

export default component.exports